export const formatPrice = (price, currency = "EUR", locale = "fi-FI") => {
  const parsedPrice = +(price);
  const formattedPrice = parsedPrice.toLocaleString(locale, {
    style:'currency',
    useGrouping: false,
    currency: currency,
    minimumFractionDigits: 0,
  });
  return formattedPrice;
};

export const calculateVoucherDiscount = (price, voucher) => {
  if (!voucher.valid) return price;

  if (voucher.hasOwnProperty('gift')) {
    const voucher_balance = voucher.gift.balance / 100;
    const balance_left = voucher_balance > price.price_value ? voucher_balance - price.price_value : 0;

    return {
      price_value: balance_left === 0 ? price.price_value - voucher_balance : 0,
      price_value_original: price.price_value,
      voucher_balance_left: voucher_balance,
      id: price.id,
      revision_id: price.revision_id,
    };
  } else {
    switch (voucher.discount.type) {
      case "PERCENT" :
        return {
          price_value: price.price_value * ((100 - voucher.discount.percent_off) / 100),
          price_value_original: price.price_value,
          id: price.id,
          revision_id: price.revision_id,
        };
      case "AMOUNT" :
        const amountOff = (voucher.discount.amount_off / 100);
        return {
          price_value: amountOff >= price.price_value ? 0 : price.price_value - amountOff,
          price_value_original: price.price_value,
          id: price.id,
          revision_id: price.revision_id,
        };
      default:
        return null;
    }
  }
};

export const formatVat = (vat, locale = "fi-FI") => {
  const parsedVat = +(vat);
  const formattedVat = parsedVat.toLocaleString(locale, {
    style: 'percent',
    useGrouping: false,
    minimumFractionDigits: 0,
  });
  return formattedVat;
};



// WEBPACK FOOTER //
// ./src/utils/price-utils.js